import * as types from '../constants';

export function loadSplunk() {
  return {
    type: types.LOAD_SPLUNK,
  };
}

export function updateSplunk(data, uuid) {
  return {
    type: types.UPDATE_SPLUNK,
    data,
    uuid,
  };
}

export function saveSplunk(data) {
  return {
    type: types.SAVE_SPLUNK,
    data,
  };
}

export function getAccessTokenBrowserling(data) {
  return {
    type: types.GET_ACCESS_TOKEN_BROWSERLING,
    data,
  };
}

export function deleteSplunk(uuid) {
  return {
    type: types.DELETE_SPLUNK,
    uuid,
  };
}

export function loadSlack() {
  return {
    type: types.LOAD_SLACK,
  };
}

export function saveSlack(data) {
  return {
    type: types.SAVE_SLACK,
    data,
  };
}

export function updateSlack(data, uuid) {
  return {
    type: types.UPDATE_SLACK,
    data,
    uuid,
  };
}

export function deleteSlack(uuid) {
  return {
    type: types.DELETE_SLACK,
    uuid,
  };
}

export function loadMTeams() {
  return {
    type: types.LOAD_M_TEAMS,
  };
}

export function saveMTeams(data) {
  return {
    type: types.SAVE_M_TEAMS,
    data,
  };
}

export function updateMTeams(data, uuid) {
  return {
    type: types.UPDATE_M_TEAMS,
    data,
    uuid,
  };
}

export function deleteMTeams(uuid) {
  return {
    type: types.DELETE_M_TEAMS,
    uuid,
  };
}
